import { AbstractRenderer, BusinessComponent, BusinessComponentOptions, StaticParagraphComponent } from '@blk/simba';
import { HeadingComponent, HeadingLevel } from '@ddt-web/pdf-components';

export class EsgLowerCarbonFootprintComponent extends BusinessComponent {
	constructor(name: string, public visible: boolean = true) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible }));
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		panels.push(new HeadingComponent('LOWER_CARBON_FOOTPRINT_HEADER_PDF', 'LOWER CARBON FOOTPRINT', HeadingLevel.H2));
		panels.push(
			new StaticParagraphComponent(
				'LOWER_CARBON_FOOTPRINT_SUBTEXT_PDF',
				'LOWER_CARBON_FOOTPRINT_SUBTEXT_PDF',
				{},
				{ marginBottom: 10 },
				['text-10']
			)
		);
		return panels;
	}
}
